import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS, GET_PAYMENT_STATUS_COUNT } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPaymentStatsReportMethods extends IPluginMethodMap {
  getPaymentStatusProps(args: any): Promise<any>;
}

export class PaymentStatsReportPageService implements IAgentPlugin {
  readonly methods: IPaymentStatsReportMethods;

  constructor() {
    this.methods = {
      getPaymentStatusProps: this.getPaymentStatusProps.bind(this),
    };
  }

  async getPaymentStatusProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      const presentationRes = await client.query({
        query: GET_PRESENTATIONS,
        variables: {
          filter: {},
          options: {
            limit: 10,
            skip: 0,
            sort: {
              field: "status",
              order: "asc",
            },
          },
        },
        fetchPolicy: "network-only",
      });

      const presentations =
        presentationRes?.data?.getPresentations?.content || [];

      const defaultPresentation = presentations?.[0]?.id;

      const selectedPresentation =
        args?.criteria?.status || args?.criteria || defaultPresentation;

      const paymentStatusRes = await client.query({
        query: GET_PAYMENT_STATUS_COUNT,
        variables: {
          presentation: selectedPresentation,
        },
        fetchPolicy: "network-only",
      });

      const countData = paymentStatusRes?.data?.getPaymentStatusCount || {};
      console.log(this.formatPaymentStatusCount(countData));
      return {
        paymentStatusCount: this.formatPaymentStatusCount(countData),
        defaultPresentation,
        selectedPresentation,
        typeOfSearch: presentations.map((item: any) => ({
          value: item?.id,
          label: item?.name,
        })),
      };
    } catch (err) {
      console.log("error in payment status count", err);
      return {
        isEmpty: true,
        paymentStatusCount: [],
      };
    }
  }

  private formatPaymentStatusCount(data: any) {
    return [
      {
        paymentStatus: "Paid",
        count: Number(data?.Paid || 0),
      },
      {
        paymentStatus: "Partial",
        count: Number(data?.Partial || 0),
      },
      {
        paymentStatus: "UnPaid",
        count: Number(data?.UnPaid || 0),
      },
    ];
  }

  getStaticPageContent() {
    return {};
  }
}
